/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type CreateClusterInviteAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class CreateClusterInviteAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateClusterInviteAuthClusterResponse429ResponseBodyData;

  constructor(
    err: CreateClusterInviteAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateClusterInviteAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type CreateClusterInviteAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class CreateClusterInviteAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateClusterInviteAuthClusterResponse409ResponseBodyData;

  constructor(
    err: CreateClusterInviteAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateClusterInviteAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type CreateClusterInviteAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class CreateClusterInviteAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateClusterInviteAuthClusterResponse404ResponseBodyData;

  constructor(
    err: CreateClusterInviteAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateClusterInviteAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type CreateClusterInviteAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class CreateClusterInviteAuthClusterResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateClusterInviteAuthClusterResponseResponseBodyData;

  constructor(
    err: CreateClusterInviteAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateClusterInviteAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type CreateClusterInviteAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class CreateClusterInviteAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateClusterInviteAuthClusterResponseBodyData;

  constructor(
    err: CreateClusterInviteAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateClusterInviteAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type CreateClusterInviteResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class CreateClusterInviteResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateClusterInviteResponseBodyData;

  constructor(
    err: CreateClusterInviteResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateClusterInviteResponseBody";
  }
}

/** @internal */
export const CreateClusterInviteAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateClusterInviteAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type CreateClusterInviteAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateClusterInviteAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateClusterInviteAuthClusterResponse429ResponseBody
  > = z.instanceof(CreateClusterInviteAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateClusterInviteAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateClusterInviteAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type CreateClusterInviteAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateClusterInviteAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateClusterInviteAuthClusterResponse409ResponseBody
  > = z.instanceof(CreateClusterInviteAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateClusterInviteAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateClusterInviteAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type CreateClusterInviteAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateClusterInviteAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateClusterInviteAuthClusterResponse404ResponseBody
  > = z.instanceof(CreateClusterInviteAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateClusterInviteAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateClusterInviteAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type CreateClusterInviteAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateClusterInviteAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    CreateClusterInviteAuthClusterResponseResponseBody
  > = z.instanceof(CreateClusterInviteAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateClusterInviteAuthClusterResponseBody$inboundSchema:
  z.ZodType<CreateClusterInviteAuthClusterResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new CreateClusterInviteAuthClusterResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type CreateClusterInviteAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateClusterInviteAuthClusterResponseBody$outboundSchema:
  z.ZodType<
    CreateClusterInviteAuthClusterResponseBody$Outbound,
    z.ZodTypeDef,
    CreateClusterInviteAuthClusterResponseBody
  > = z.instanceof(CreateClusterInviteAuthClusterResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateClusterInviteResponseBody$inboundSchema: z.ZodType<
  CreateClusterInviteResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new CreateClusterInviteResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type CreateClusterInviteResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateClusterInviteResponseBody$outboundSchema: z.ZodType<
  CreateClusterInviteResponseBody$Outbound,
  z.ZodTypeDef,
  CreateClusterInviteResponseBody
> = z.instanceof(CreateClusterInviteResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
